// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SET_USER_DETAILS: "SET_USER_DETAILS",
  SET_USER_PERSONAL_DETAILS: "SET_USER_PERSONAL_DETAILS",
  SET_USER_BANK_DETAILS: "SET_USER_BANK_DETAILS",
  SET_USER_PERSONAL_CHECK: "SET_USER_PERSONAL_CHECK",
  SET_USER_BANK_CHECK: "SET_USER_BANK_CHECK",
  SET_DEPOSIT_ORDERS: "SET_DEPOSIT_ORDERS",
  SET_WITHDRAW_ORDERS: "SET_WITHDRAW_ORDERS",
  SET_ORDERS_HISTORY: "SET_ORDERS_HISTORY",
  SET_VIEW_ORDER: "SET_VIEW_ORDER",
  SET_APPROVED_TRANSACTION: "SET_APPROVED_TRANSACTION",
  SET_TRANSACTION_BY_TRANSACTION_ID: "SET_TRANSACTION_BY_TRANSACTION_ID",
  SET_PASSWORD_UPDATE: "SET_PASSWORD_UPDATE",
  SET_USER_BANKS: "SET_USER_BANKS",
  UPDATE_USER_PERSONAL_DETAILS: "UPDATE_USER_PERSONAL_DETAILS",
  SET_ADD_NEW_BANK: "SET_ADD_NEW_BANK",
  SET_COLLATERAL_SUBMITTED: "SET_COLLATERAL_SUBMITTED",
  SET_CREATE_REGION: "SET_CREATE_REGION",
  SET_REGION_BANK: "SET_REGION_BANK",
  SET_CREATE_ORDER: "SET_CREATE_ORDER",
  SET_CREATE_ORDER_STATUS: "SET_CREATE_ORDER_STATUS",
  SET_CONFIRM_ORDER: "SET_CONFIRM_ORDER",
  SET_UPLOAD_VIDEO: "SET_UPLOAD_VIDEO",
  SET_USER_DEPOSIT_ORDERS: "SET_USER_DEPOSIT_ORDERS",
  SET_USER_WITHDRAW_ORDERS: "SET_USER_WITHDRAW_ORDERS",
  SET_USER_WALLET_DETAILS: "SET_USER_WALLET_DETAILS",
  SET_DEPOSIT_ORDER_LOADER: "SET_DEPOSIT_ORDER_LOADER",
  SET_WITHDRAW_ORDER_LOADER: "SET_WITHDRAW_ORDER_LOADER",
  SET_HISTORY_LOADER: "SET_HISTORY_LOADER",
  SET_SETTINGS_LOADER: "SET_SETTINGS_LOADER",
  SET_CHAT_ROOM: "SET_CHAT_ROOM",
  SET_SEND_MESSAGE: "SET_SEND_MESSAGE",
  RESET_USER_STATE: "RESET_USER_STATE",
  SET_DEFAULT_BANK: "SET_DEFAULT_BANK",
  SET_TICKER_DATA: "SET_TICKER_DATA",
  SET_CHANGE_LOGIN_CREDENTIAL: "SET_CHANGE_LOGIN_CREDENTIAL",
  SET_DISPUTED_DEPOSIT_ORDERS: "SET_DISPUTED_DEPOSIT_ORDERS",
  SET_DISPUTED_WITHDRAW_ORDERS: "SET_DISPUTED_WITHDRAW_ORDERS",
  SET_ORDER_VOTE: "SET_ORDER_VOTE",
  SET_JURY_HISTORY: "SET_JURY_HISTORY",
  SET_ALL_ORDERS: "SET_ALL_ORDERS",
  SET_CUSTODIAN_ORDERS:'SET_CUSTODIAN_ORDERS',
  SET_USER_UPDATED_ROLE: "SET_USER_UPDATED_ROLE",
  SET_USER_PROFILE_PICTURE: "SET_USER_PROFILE_PICTURE",
  SET_USER_AVAILABILITY: "SET_USER_AVAILABILITY",
  SET_USER_REWARDS: "SET_USER_REWARDS",
  SET_JURY_PROOF: "SET_JURY_PROOF",
  SET_JURY_PROOF_REQUEST: "SET_JURY_PROOF_REQUEST",
  SET_JURY_PROOF_SUBMIT: "SET_JURY_PROOF_SUBMIT",
  SET_OPEN_ORDER_DISPUTE: "SET_OPEN_ORDER_DISPUTE",
  SET_MAKE_DEFAULT_BANK: "SET_MAKE_DEFAULT_BANK",
  SET_OPEN_ORDER_APPEAL: "SET_OPEN_ORDER_APPEAL",
  SET_VOTE_APPEAL_ORDER: "SET_VOTE_APPEAL_ORDER",
  SET_USER_BATCH_EARNING: "SET_USER_BATCH_EARNING",
  SET_JURY_LIVE_ORDERS: "SET_JURY_LIVE_ORDERS",
  SET_APPEALED_TRANSACTIONS: 'SET_APPEALED_TRANSACTIONS',
  SET_APPEALED_COMPLETE_ORDERS: 'SET_APPEALED_COMPLETE_ORDERS',
  SET_CUSTODIAN_PORTFOLIO: 'SET_CUSTODIAN_PORTFOLIO',
  SET_CUSTODIAN_DASHBOARD_DATA: 'SET_CUSTODIAN_DASHBOARD_DATA',
  SET_USER_PORTFOLIO: "SET_USER_PORTFOLIO",
  SET_TRANSACTION_BY_ID_LOADER: "SET_TRANSACTION_BY_ID_LOADER",
  SET_BUTTON_LOADER: "SET_BUTTON_LOADER",
  SET_APPROVED_STATUS: 'SET_APPROVED_STATUS',
  SET_USER_DASHBOARD_DATA: 'SET_USER_DASHBOARD_DATA',
  SET_CLOSE_DISPUTE_AFTER_JURY_VOTES: 'SET_CLOSE_DISPUTE_AFTER_JURY_VOTES',
  SET_ADD_PROOF: 'SET_ADD_PROOF',
  SET_CHAT_WITH_LOADER: 'SET_CHAT_WITH_LOADER',
  SET_USER_BATCH_PORTFOLIO_DATA: 'SET_USER_BATCH_PORTFOLIO_DATA',
  SET_USER_TOTAL_TRANSFERS:'SET_USER_TOTAL_TRANSFERS',
  SET_CUST_BATCHES:'SET_CUST_BATCHES',
  SET_CUSTODIAN_POOL_AMOUNT: 'SET_CUSTODIAN_POOL_AMOUNT',
  SET_CUSTODIAN_RAMP_VALUE: 'SET_CUSTODIAN_RAMP_VALUE',
  SET_CLAIM_AVAILABLE_AMOUNT: 'SET_CLAIM_AVAILABLE_AMOUNT',
  SET_ALL_STAKING_DATA: 'SET_ALL_STAKING_DATA',
  SET_ALL_STAKING_LOADER: 'SET_ALL_STAKING_LOADER',
  SET_ALL_CARDS_LOADER:'SET_ALL_CARDS_LOADER',
  SET_SOCKET_INSTANCE:'SET_SOCKET_INSTANCE',
  SET_CHAT: 'SET_CHAT',
  SUCCESS_MESSAGE:'SUCCESS_MESSAGE',
  SET_CUSTODIAN_EARNINGS_AMOUNT:"SET_CUSTODIAN_EARNINGS_AMOUNT",
  SET_USER_BALANCE:"SET_USER_BALANCE",
  DELETE_BANK: "DELETE_BANK",
  SET_DISPUTE_LOADER:"SET_DISPUTE_LOADER",
  FETCH_COUNTRIES: 'FETCH_COUNTRIES',
  FETCH_STATES: 'FETCH_STATES',
  FETCH_CITIES: 'FETCH_CITIES'
};

//enums for earning role
export  const EarningRole ={
  CUSTEARN:"custEarn",
  USEREARN: "userEarn",
  JURYPOOLEARN:'juryPoolEarn',
  CUSTPOOLEARN:'custPoolEarn'

}